import React from 'react';
interface Testimonial {
  initials: string;
  quote: string;
  name: string;
  location: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
  columns?: 2 | 3;
  showStars?: boolean;
}
export function Testimonials({
  testimonials,
  columns = 3,
  showStars = false
}: TestimonialsProps) {
  const gridClass = columns === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2';
  return <div className={`grid grid-cols-1 ${gridClass} gap-6`} data-id="element-244">
      {testimonials.map((testimonial, i) => <div key={i} className="bg-white p-6 rounded-lg shadow-md" data-id="element-245">
          <div className="flex items-center gap-3 mb-4" data-id="element-246">
            <div className="w-12 h-12 bg-carbon rounded-full flex items-center justify-center text-white font-bold flex-shrink-0" data-id="element-247">
              {testimonial.initials}
            </div>
            {showStars && <div className="flex gap-0.5 text-sci-orange text-lg" aria-label="5 de 5 estrellas" data-id="element-248">
                <span data-id="element-249">★</span>
                <span data-id="element-250">★</span>
                <span data-id="element-251">★</span>
                <span data-id="element-252">★</span>
                <span data-id="element-253">★</span>
              </div>}
          </div>
          <p className="text-gray-700 mb-4 text-sm md:text-base leading-relaxed" data-id="element-254">
            "{testimonial.quote}"
          </p>
          <div className="font-bold text-carbon text-sm" data-id="element-255">
            {testimonial.name}
          </div>
          <div className="text-xs text-gray-500" data-id="element-256">{testimonial.location}</div>
        </div>)}
    </div>;
}